export default "__VITE_ASSET__186804b4__"